import { API_BASE_URL } from "./config";

const API_BASE_ADMIN = `${API_BASE_URL}/admins`; // Cambia si usas otro puerto o dominio

export const AdminAPI = {
  // 🔹 Login de administrador
  async login(correo, contrasena) {
    const res = await fetch(`${API_BASE_ADMIN}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include", // importante para enviar cookies
      body: JSON.stringify({ correo, contrasena }),
    });

    if (!res.ok) {
      let errorData;
      try {
        errorData = await res.json();
      } catch {
        const text = await res.text();
        errorData = { mensaje: text };
      }
      throw new Error(errorData.mensaje || "Error al iniciar sesión");
    }

    return true; // la cookie JWT se establece automáticamente
  },

  // 🔹 Logout
  async logout() {
    const res = await fetch(`${API_BASE_ADMIN}/logout`, {
      method: "POST",
      credentials: "include",
    });
    if (!res.ok) throw new Error("Error al cerrar sesión");
    return true;
  },

  // 🔹 Obtener datos del administrador autenticado
  async me() {
    const res = await fetch(`${API_BASE_ADMIN}/me`, {
      method: "GET",
      credentials: "include",
    });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || "No autenticado");
    }
    return res.json();
  },

  // 🔹 Cambiar contraseña del administrador autenticado
  async cambiarContrasena(nuevaContrasena) {
    const res = await fetch(`${API_BASE_ADMIN}/password`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ nuevaContrasena }),
      credentials: "include",
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || "Error al cambiar la contraseña");
    }

    return true;
  },

  // 🔹 Obtener todos los administradores (opcional, si sigue funcionando igual)
  async getAll() {
    const res = await fetch(API_BASE_ADMIN, { credentials: "include" });
    if (!res.ok) throw new Error("Error al obtener administradores");
    return res.json();
  },

  // 🔹 Crear administrador
  async create(admin) {
    const res = await fetch(API_BASE_ADMIN, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(admin),
      credentials: "include",
    });
    if (!res.ok) throw new Error("Error al crear administrador");
    return res.json();
  },

  // 🔹 Eliminar administrador
  async delete(id) {
    const res = await fetch(`${API_BASE_ADMIN}/${id}`, {
      method: "DELETE",
      credentials: "include",
    });
    if (!res.ok) throw new Error("Error al eliminar administrador");
  },
};

const API_BASE_BLOG = `${API_BASE_URL}/blogs`;

export const BlogAPI = {
  // 🔹 Crear un nuevo blog
  async create(blog) {
    const res = await fetch(API_BASE_BLOG, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(blog),
    });

    if (!res.ok) throw new Error("Error al crear el blog");
    return res.json();
  },

  // 🔹 Actualizar un blog existente
  async update(id, blog) {
    const res = await fetch(`${API_BASE_BLOG}/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(blog),
    });

    if (!res.ok) {
      let errorData;
      try {
        errorData = await res.json();
      } catch {
        const text = await res.text();
        errorData = { mensaje: text };
      }
      throw new Error(errorData.mensaje || "Error al actualizar el blog");
    }

    return res.json();
  },

  // 🔹 Obtener todos los blogs
  async getAll() {
    const res = await fetch(API_BASE_BLOG);
    if (!res.ok) throw new Error("Error al obtener los blogs");
    return res.json();
  },

  // 🔹 Obtener un blog por ID
  async getById(id) {
    const res = await fetch(`${API_BASE_BLOG}/${id}`);
    if (!res.ok) throw new Error("Error al obtener el blog");
    return res.json();
  },

  // 🔹 Obtener un blog por slug
  async getBySlug(slug) {
    const res = await fetch(`${API_BASE_BLOG}/slug/${slug}`);
    if (!res.ok) throw new Error("Error al obtener el blog por slug");
    return res.json();
  },

  // 🔹 Eliminar blog
  async delete(id) {
    const res = await fetch(`${API_BASE_BLOG}/${id}`, {
      method: "DELETE",
    });
    if (!res.ok) throw new Error("Error al eliminar el blog");
  },
};


const API_BASE_MENSAJES = `${API_BASE_URL}/mensajes`;

export const MensajeAPI = {
  // 🔹 Crear mensaje
  async create(mensaje) {
    const res = await fetch(API_BASE_MENSAJES, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(mensaje),
    });
    if (!res.ok) throw new Error("Error al enviar el mensaje");
    return res.json();
  },

  // 🔹 Obtener todos los mensajes
  async getAll() {
    const res = await fetch(API_BASE_MENSAJES);
    if (!res.ok) throw new Error("Error al obtener los mensajes");
    return res.json();
  },

  // 🔹 Obtener mensaje por ID
  async getById(id) {
    const res = await fetch(`${API_BASE_MENSAJES}/${id}`);
    if (!res.ok) throw new Error("Error al obtener el mensaje");
    return res.json();
  },

  // 🔹 Eliminar mensaje
  async delete(id) {
    const res = await fetch(`${API_BASE_MENSAJES}/${id}`, {
      method: "DELETE",
    });
    if (!res.ok) throw new Error("Error al eliminar el mensaje");
  },
};
